import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
class Tableservers extends Component {


    state = {

    }

    servidorDetalle(id) {
        this.props.history.push("/detalle-servidor/" + id);
    }


    render() {

        return (
            <Fragment>
                <h4 className="mb-center">SERVIDORES</h4>
                <div className="table-responsive">
                    <table className="table table-bordered table-striped table-condensed">
                        <thead>
                            <tr>
                                <th className="bg-primary text-white">#</th>
                                <th className="bg-primary text-white">SERVIDOR</th>
                                <th className="bg-primary text-white">ESTATUS</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.listaServidores.map((server, i) => (
                                <tr key={i}>
                                    <td>{server.id_servidor}</td>
                                    <td>{server.nombre}</td>
                                    <td align="center">
                                        {server.estado === "1" ? <i data-tooltip="" className="fas fa-circle text-success"></i> : <i className="fas fa-circle text-danger"></i>}
                                    </td>

                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Fragment>
        );
    }
}

export default withRouter(Tableservers);


// WEBPACK FOOTER //
// ./src/components/servers/Tableservers.js